import React from "react";
import { Calendar, MapPin, Zap } from "lucide-react";

const CustomQuestions = ({ questionRef }) => {
  const customQuestions = {
    questions: [
      {
        id: "1",
        question: "Are you willing to relocate to Mangalore?",
        answer: "Yes",
      },
      {
        id: "2",
        question: "What is your earliest available start date?",
        answer: "Jan 2025",
      },
      {
        id: "3",
        question: "What is your superpower?",
        answer: "Task Execution in time",
      },
    ],
  };

  const iconMap = {
    1: <MapPin className="h-5 w-5 text-primary" />,
    2: <Calendar className="h-5 w-5 text-primary" />,
    3: <Zap className="h-5 w-5 text-primary" />,
  };

  return (
    <div id="question" ref={questionRef} className="pb-5">
      {/* <div className="flex items-center mb-6">
        <div className="h-8 w-8 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center mr-3">
          <CircleHelp className="h-4 w-4" />
        </div>
        <h2 className="text-xl font-bold">Custom Questions</h2>
      </div> */}

      {/* <CardList.Card outerClassName="border rounded-lg shadow-sm p-4"> */}
      <h4 className="text-sm font-medium text-neutral-500 mb-3">
          Custom Questions{" "}
        </h4>
        <p className="text-sm text-gray-500 mb-4">
          Additional information provided by the candidate
        </p>
        <div className="space-y-6">
          {customQuestions.questions.map((q) => (
            <div key={q.id} className="flex items-start space-x-4">
              <div className="mt-0.5 bg-gray-100 p-2 rounded-md">
                {iconMap[q.id] || (
                  <MapPin className="h-5 w-5 text-primary" />
                )}{" "}
              </div>
              <div className="space-y-1">
                <h4 className="text-sm font-medium leading-none">
                  {q.question}
                </h4>
                <p className="text-sm text-gray-700 mt-2 bg-gray-50 p-2 rounded-md">
                  {q.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      {/* </CardList.Card> */}
    </div>
  );
};

export default React.memo(CustomQuestions);
